<!-- URL's may change -->
<!-- Ordering Footer -->
<div *ngIf="isOrdering"   class="app-footer order-footer">
  <footer class="app-footer-order wab-container container-constraint">
    <div class="footer-order">
          <div class="footer-bt-link footer-bt-link-top">
            <a [routerLink]="['/home/faqs']" [queryParams]="{type: 'ordering'}" aria-label="View Frequently Asked Questions" >FAQs</a>
          </div>
          <div class="footer-bt-link footer-bt-link-top">
            <a [routerLink]="['/contact-us']" aria-label="Contact Customer Care">Contact Customer Care</a>
          </div>

        <hr class="hr-opacity visible-xs visible-sm">

        <div class="footer-order-right-div">
          <div class="footer-bt-link footer-bt-link-btm">
            <a href="https://wbimageserver.whataburger.com/Nutrition.pdf " aria-label="View Nutritional Information">Nutritional Information</a>
          </div>
          <div class="footer-bt-link footer-bt-link-btm">
            <a [routerLink]="['/home/termsandconditions']" aria-label="View Terms and Conditions">Terms &amp; Conditions</a>
          </div>
          <div class="footer-bt-link footer-bt-link-btm">
            <a [routerLink]="['/home/privacypolicy']" aria-label="View Privacy Policy">Privacy Policy</a>
          </div>
          <div class="footer-bt-link footer-bt-link-btm">
            <a [routerLink]="['/home/accessibility']" aria-label="View Accessibility Statement">Accessibility Statement</a>
          </div>
          <div class="footer-bt-link">
            <a class="optanon-toggle-display" style="padding-left: 40px; background-image: url(../../../assets/images/navigation/privacyoptions.svg); background-repeat: no-repeat;">Your Privacy Choices</a>
          </div>
          <div class="footer-logo-sm">
            <img src="../../../assets/images/navigation/whataburger-footer-sm-logo.png" alt="whataburger small footer logo" />
          </div>
          <div class="footer-logo-lg">
            <img src="../../../assets/images/navigation/whataburger-footer-logo.png" alt="whataburger footer logo" />
          </div>
        </div>
    </div>
  </footer>
</div>
<!-- Main Footer -->
<div *ngIf="!isOrdering" class="app-footer">
  <footer class="app-footer-main wab-container container-constraint">
    <div class="footer-div-padding col-xs-12">
      <div class="col-md-2 footer-col footer-col-first-padding">
          <h4 class="footer-title-margin"><span class="footer-text-underline"><a href="https://stories.whataburger.com/our-history/">COMPANY</a></span></h4>
        <ul class="hidden-xs hidden-sm">
          <li>
            <a href="https://stories.whataburger.com/our-history/">Our History</a>
          </li>
          <li>
            <a href="https://stories.whataburger.com/press-room">Press Room</a>
          </li>
          <li>
            <a href="https://locations.whataburger.com/">Locations</a>
          </li>
          <li>
            <a [routerLink]="['/company/portals']">Portals</a>
          </li>
          <li>
            <a [routerLink]="['/franchise']">Franchising</a>
          </li>
          <li>
            <a aria-label="Frequently Asked Questions" [routerLink]="['/home/faqs']" [queryParams]="{type: 'company'}">FAQs</a>
          </li>
        </ul>
        <ul class="visible-xs visible-sm">
          <li>
            <a aria-label="Frequently Asked Questions" [routerLink]="['/home/faqs']" [queryParams]="{type: 'company'}">FAQs</a>
          </li>
        </ul>
      </div>

      <div class="col-md-4 footer-col footer-col-second-padding">
          <h4 class="footer-title-margin"><span class="footer-text-underline"><a href="http://shop.whataburger.com/">SHOP WHATASTORE<sup>&#174;</sup></a></span></h4>
        <div class="col-md-5 hidden-xs hidden-sm footer-items-padding">
          <ul>
            <li>
              <a href="https://shop.whataburger.com/apparel">Apparel</a>
            </li>
            <li>
              <a href="https://shop.whataburger.com/kids">Kids</a>
            </li>
            <li>
              <a href="https://shop.whataburger.com/gifts">Gifts</a>
            </li>
            <li>
              <a href="https://shop.whataburger.com/groceries">Groceries</a>
            </li>
            <li class="footer-item-last">
              <a href="https://shop.whataburger.com/bundles/">Accessories</a>
            </li>
          </ul>
        </div>

        <div class="col-md-7 hidden-xs hidden-sm footer-items-padding">
          <ul>
            <li>
              <a href="https://whataburger.com/buy-gift-cards">Buy Gift Card</a>
            </li>
            <li>
              <a [routerLink]="['/online-gift-card/select']">Send Online Gift Card</a>
            </li>
            <li>
              <a href="https://whataburger.com/gift-card-balance">Gift Card Balance</a>
            </li>
            <li>
              <a href="https://shop.whataburger.com/account.php">My Account</a>
            </li>          
            <li class="footer-item-last">
              <a aria-label="Frequently Asked Questions" [routerLink]="['/home/faqs']" [queryParams]="{type: 'whatastore'}">FAQs</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-md-3 footer-col footer-col-third-padding">
          <h4 class="footer-title-margin">
            <span class="footer-text-underline">
              <a class="pointer" [routerLink]="['/benefits']">ORDERING &amp; REWARDS</a>
            </span>
          </h4>
        <ul>
          <li>
            <a  class="pointer" id="scroll-top" [routerLink]="['/benefits']">MyWhataburger Benefits</a>
          </li>
          <li>
            <a aria-label="View Frequently Asked Questions" [routerLink]="['/home/faqs']" [queryParams]="{type: 'ordering'}">FAQs</a>
          </li>
          <li>
            <div class="col-sm-12 col-xs-12 store-img-div">
              <div class="col-md-12 app-store-div" *showItStandard="['iphone','ipad']" >
                <a target="_blank" href="https://itunes.apple.com/us/app/whataburger/id1141643627?mt=8">
                  <img src="../../../assets/images/navigation/App Store Icon.png" alt="Download on the App Store" class="app-store-icon" />
                </a>
              </div>
              <div class="col-md-12 app-store-div" *isDesktop>
                <a target="_blank" href="https://itunes.apple.com/us/app/whataburger/id1141643627?mt=8">
                  <img src="../../../assets/images/navigation/App Store Icon.png" alt="Download on the App Store" class="app-store-icon" />
                </a>
              </div>
              <div class="col-md-12 play-store-div" *showItStandard="['android mobile','android tablet']">
                <a target="_blank" href="https://play.google.com/store/apps/details?id=wb.mobile.cx.client.droid">
                  <img src="../../../assets/images/navigation/Google Store Icon.png" alt="Get It on Google Play" class="play-store-icon" />
                </a>
              </div>
              <div class="col-md-12 play-store-div" *isDesktop>
                <a target="_blank" href="https://play.google.com/store/apps/details?id=wb.mobile.cx.client.droid">
                  <img src="../../../assets/images/navigation/Google Store Icon.png" alt="Get It on Google Play" class="play-store-icon" />
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="col-md-3 col-xs-12 footer-col footer-col-fourth-padding">

          <h4 class="footer-title-margin"><span class="footer-text-underline"><a  [routerLink]="['/contact-us']">CONNECT</a></span></h4>
        <ul>
          <li class="pointer">
            <a (click)="redirectTo('contact-us')">Contact Customer Care</a>
          </li>
          <li>
            <a [routerLink]="['/home/signup']">Sign Up for Emails</a>
          </li>
          <li>
            <div class="pull-left scl-btn-inline-div">
              <div class="scl-btn-div">
                <a href="https://www.facebook.com/whataburger">
                  <img src="../../../assets/images/navigation/icnFacebook.png" alt="Visit our Facebook page" class="scl-btn" />
                </a>
              </div>
              <div class="scl-btn-div">
                <a href=" https://twitter.com/whataburger">
                  <img src="../../../assets/images/navigation/icnTwitter.png" alt="Follow us on Twitter" class="scl-btn" />
                </a>
              </div>
              <div class="scl-btn-div">
                <a href="https://instagram.com/whataburger">
                  <img src="../../../assets/images/navigation/icnInstagram.png" alt="Follow us on Instagram" class="scl-btn" />
                </a>
              </div>
              <div class="scl-btn-div">
                <a href="https://www.tiktok.com/@whataburger">
                  <img src="../../../assets/images/navigation/icnTiktok.png" alt="Follow us on TikTok" class="scl-btn" />
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>

    <hr class="hr-opacity">

    <div class="col-xs-12 footer-bottom-padding no-pad">
      <div class="footer-bt-link">
        <a [routerLink]="['/contact-us/corporate-info']">Contact Us</a>
      </div>
      <div class="footer-bt-link">
        <a href="https://wbimageserver.whataburger.com/Nutrition.pdf">Nutritional Information</a>
      </div>
      <div class="footer-bt-link">
        <a [routerLink]="['/home/termsandconditions']">Terms &amp; Conditions</a>
      </div>
      <div class="footer-bt-link">
        <a [routerLink]="['/home/privacypolicy']">Privacy Policy</a>
      </div>
      <div class="footer-bt-link">
        <a [routerLink]="['/home/accessibility']">Accessibility Statement</a>
      </div>
      <div class="footer-bt-link">
        <a class="optanon-toggle-display" style="padding-left: 40px; background-image: url(../../../assets/images/navigation/privacyoptions.svg); background-repeat: no-repeat;">Your Privacy Choices</a>
      </div>
      <div class="footer-bt-link" [style.display]="!isProd ? 'block' : 'none'">
        <a class="app-version" href="">Version: {{version}} </a>
      </div>
      <div class="footer-logo">
        <img src="../../../assets/images/navigation/whataburger-footer-logo.png" alt="whataburger footer logo" />
      </div>
    </div>
    </div>

  </footer>
</div>
